import { render, staticRenderFns } from "./gamefication.vue?vue&type=template&id=f1231cc0&scoped=true&"
import script from "./gamefication.vue?vue&type=script&lang=js&"
export * from "./gamefication.vue?vue&type=script&lang=js&"
import style0 from "./gamefication.vue?vue&type=style&index=0&id=f1231cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1231cc0",
  null
  
)

export default component.exports